//link and components
import React, { useState } from "react"
import { Link } from "gatsby"
import Navsearch from "./navbarsearch"
//imgs
import logotxt from "../images/header-logo.png"
import radioonline from "../assets/radioicon.svg"
//styles
import "../Styles/navbar.scss"
import "bootstrap/dist/css/bootstrap.min.css"
import { Navbar, Nav, NavDropdown } from "react-bootstrap"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

const TheNavbar = () => {
  const [hover1, setHover1] = useState(false)
  const [hover2, setHover2] = useState(false)
  const [hover3, setHover3] = useState(false)
  const [hover4, setHover4] = useState(false)

  return (
    <div className="navdiv">
      <Navbar className="navbar" expand="xl" variant="dark" fixed="top">
        <Navbar.Brand className="navbrand">
          <Link to="/">
            <img
              src={logotxt}
              width="100"
              className="d-inline-block align-top logo-txt navbar-header"
              alt="hinote logo"
            />
          </Link>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav" className="menu">
          <Nav className="mr-auto navstyle" id="nav-items">
            <NavDropdown
              title="MUSIC"
              onMouseEnter={() => {
                setHover1(true)
                console.log("trueeeeeeeeee")
              }}
              onMouseLeave={() => {
                setHover1(false)
                console.log("trueeeeeeeeee")
              }}
              className="nav-items dropdown"
              show={hover1}
              noCaret
            >
              <NavDropdown.Item href="/topmusics" className="drop-items">
                TOP MUSICS IN HINOTE
              </NavDropdown.Item>
              <NavDropdown.Item href="/newmusics">NEW MUSICS</NavDropdown.Item>
              <NavDropdown.Item href="/musicvideos">
                MUSIC VIDEOS
              </NavDropdown.Item>
              <NavDropdown.Item href="/albums">ALBUMS</NavDropdown.Item>
              <NavDropdown.Item href="/comingsoon">
                COMING SOON
              </NavDropdown.Item>
              <NavDropdown.Item href="/suggesion">
                HINOTE SUGGESION
              </NavDropdown.Item>
            </NavDropdown>

            <NavDropdown
              title="MUSIC MAGAZINE"
              className="dropdown nav-items"
              onMouseEnter={() => {
                setHover2(true)
                console.log("trueeeeeeeeee")
              }}
              onMouseLeave={() => {
                setHover2(false)
                console.log("trueeeeeeeeee")
              }}
              show={hover2}
              noCaret
            >
              <NavDropdown.Item href="./newspage">NEWS</NavDropdown.Item>
              <NavDropdown.Item href="./articlepage">ARTICLE</NavDropdown.Item>
              <NavDropdown.Item href="./concertpage">CONCERT</NavDropdown.Item>
            </NavDropdown>

            <NavDropdown
              title="MUSICPEDIA"
              className="dropdown nav-items"
              onMouseEnter={() => {
                setHover3(true)
                console.log("trueeeeeeeeee")
              }}
              onMouseLeave={() => {
                setHover3(false)
                console.log("trueeeeeeeeee")
              }}
              show={hover3}
              noCaret
            >
              <NavDropdown.Item href="./musicpedia">
                MUSICPEDIA
              </NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item href="./singerpage">SINGER</NavDropdown.Item>
              <NavDropdown.Item href="piecepage">PIECES</NavDropdown.Item>
              <NavDropdown.Item href="./poetpage">POETS</NavDropdown.Item>
              <NavDropdown.Item href="composerpage">COMPOSER</NavDropdown.Item>
            </NavDropdown>

            <NavDropdown
              title="ART"
              className="dropdown nav-items"
              onMouseEnter={() => {
                setHover4(true)
                console.log("trueeeeeeeeee")
              }}
              onMouseLeave={() => {
                setHover4(false)
                console.log("trueeeeeeeeee")
              }}
              show={hover4}
              noCaret
            >
              <NavDropdown.Item href="/shortfilm">SHORT FILM</NavDropdown.Item>
            </NavDropdown>

            <h4> &nbsp;</h4>

            {/* right of navbar */}
          </Nav>
          <div>
            <ul className="rightofnav">
              <li className="rightofnav-li-radio">
                <ul className="radio-online">
                  <li>
                  <svg xmlns="http://www.w3.org/2000/svg" className="radio-online-svg" viewBox="0 0 63.34 64">
  <g id="Group_7" data-name="Group 7" transform="translate(-0.33)">
    <path id="Path_2" data-name="Path 2" d="M58.78,64H5.22A4.891,4.891,0,0,1,.33,59.11V22.49A4.891,4.891,0,0,1,5.22,17.6H58.78a4.891,4.891,0,0,1,4.89,4.89V59.11A4.9,4.9,0,0,1,58.78,64ZM5.22,19.54a2.949,2.949,0,0,0-2.95,2.95V59.11a2.949,2.949,0,0,0,2.95,2.95H58.78a2.949,2.949,0,0,0,2.95-2.95V22.49a2.949,2.949,0,0,0-2.95-2.95H5.22Z"/>
    <path id="Path_3" data-name="Path 3" d="M18.91,59.46a12.462,12.462,0,1,1,8.8-3.65h0A12.343,12.343,0,0,1,18.91,59.46Zm0-22.96a10.51,10.51,0,1,0,7.43,17.94h0A10.51,10.51,0,0,0,18.91,36.5Z"/>
    <path id="Path_4" data-name="Path 4" d="M7.51,49.28a.965.965,0,0,1-.69-1.65L19.53,34.92a.969.969,0,0,1,1.37,1.37L8.19,49A.945.945,0,0,1,7.51,49.28Zm1.78,4.96a.965.965,0,0,1-.69-1.65L24.48,36.7a.969.969,0,1,1,1.37,1.37L9.98,53.95A.978.978,0,0,1,9.29,54.24Zm3.37,3.36a.965.965,0,0,1-.69-1.65L27.85,40.07a.969.969,0,0,1,1.37,1.37L13.34,57.32A.929.929,0,0,1,12.66,57.6Zm4.96,1.78a.965.965,0,0,1-.69-1.65L29.62,45.04a.969.969,0,1,1,1.37,1.37L18.3,59.1A.945.945,0,0,1,17.62,59.38ZM39.21,32.31H7.44a.965.965,0,0,1-.97-.97V23.87a.965.965,0,0,1,.97-.97H39.21a.965.965,0,0,1,.97.97v7.47A.977.977,0,0,1,39.21,32.31ZM8.41,30.37H38.24V24.84H8.41Zm48.16,1.94H44.88a.965.965,0,0,1-.97-.97V23.87a.965.965,0,0,1,.97-.97H56.57a.965.965,0,0,1,.97.97v7.47A.977.977,0,0,1,56.57,32.31ZM45.85,30.37H55.6V24.84H45.85Z"/>
    <path id="Path_5" data-name="Path 5" d="M11.3,27.85a.965.965,0,0,1-.97-.97V23.87a.97.97,0,0,1,1.94,0v3.01A.965.965,0,0,1,11.3,27.85Zm4.01,0a.965.965,0,0,1-.97-.97V23.87a.97.97,0,0,1,1.94,0v3.01A.965.965,0,0,1,15.31,27.85Zm4.01,0a.965.965,0,0,1-.97-.97V23.87a.97.97,0,0,1,1.94,0v3.01A.977.977,0,0,1,19.32,27.85Zm4,0a.965.965,0,0,1-.97-.97V23.87a.97.97,0,0,1,1.94,0v3.01A.965.965,0,0,1,23.32,27.85Zm4.01,0a.965.965,0,0,1-.97-.97V23.87a.97.97,0,1,1,1.94,0v3.01A.971.971,0,0,1,27.33,27.85Zm4,4.46a.965.965,0,0,1-.97-.97V23.87a.97.97,0,0,1,1.94,0v7.47A.971.971,0,0,1,31.33,32.31Zm4.01-4.46a.965.965,0,0,1-.97-.97V23.87a.97.97,0,0,1,1.94,0v3.01A.971.971,0,0,1,35.34,27.85Z"/>
    <g id="Group_1" data-name="Group 1">
      <path id="Path_6" data-name="Path 6" d="M17.05,19.54a.965.965,0,0,1-.97-.97,4.11,4.11,0,1,0-8.22,0,.97.97,0,0,1-1.94,0,6.05,6.05,0,0,1,12.1,0A.971.971,0,0,1,17.05,19.54Z"/>
    </g>
    <g id="Group_2" data-name="Group 2">
      <path id="Path_7" data-name="Path 7" d="M15.52,15.9a.985.985,0,0,1-.93-.68.968.968,0,0,1,.64-1.21L50.48,3.11a.969.969,0,1,1,.58,1.85L15.8,15.86A.9.9,0,0,1,15.52,15.9Z"/>
    </g>
    <g id="Group_3" data-name="Group 3">
      <path id="Path_8" data-name="Path 8" d="M48.76,59.36a8.95,8.95,0,1,1,6.33-2.62h0A8.9,8.9,0,0,1,48.76,59.36Zm0-15.97a7.01,7.01,0,1,0,4.96,11.97h0a7.01,7.01,0,0,0-4.96-11.97Z"/>
    </g>
    <g id="Group_4" data-name="Group 4">
      <path id="Path_9" data-name="Path 9" d="M48.76,53.28a2.853,2.853,0,0,1-2.03-.84,2.885,2.885,0,1,1,2.03.84Zm0-3.81a.935.935,0,1,0,.67.27A.971.971,0,0,0,48.76,49.47Z"/>
    </g>
    <g id="Group_5" data-name="Group 5">
      <path id="Path_10" data-name="Path 10" d="M50.11,50.02a.965.965,0,0,1-.69-1.65l2.06-2.06a.969.969,0,1,1,1.37,1.37l-2.06,2.06A.929.929,0,0,1,50.11,50.02Z"/>
    </g>
    <g id="Group_6" data-name="Group 6">
      <path id="Path_11" data-name="Path 11" d="M53.03,6.66a3.33,3.33,0,1,1,3.33-3.33A3.329,3.329,0,0,1,53.03,6.66Zm0-4.72a1.39,1.39,0,1,0,1.39,1.39A1.393,1.393,0,0,0,53.03,1.94Z"/>
    </g>
  </g>
</svg>
                  </li>
                  <li className="onlineradio">
                    <p>online radio</p>
                  </li>
                </ul>
              </li>
              <li className="rightofnav-li item-margin-nav">
                <Navsearch></Navsearch>
              </li>
              <li className="rightofnav-li">
                <ul className="social-on-nav">
                  <li>
                    <FontAwesomeIcon
                      icon={["fab", "telegram"]}
                      className="fa-s social-icon"
                    />
                  </li>
                  <li>
                    <FontAwesomeIcon
                      icon={["fab", "instagram"]}
                      className="fa-s social-icon"
                    />
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </Navbar.Collapse>
      </Navbar>
    </div>
  )
}

export default TheNavbar
